import React, { useState } from "react";
import { makeStyles } from "@material-ui/styles";
import { Link } from "@reach/router";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import { fade } from "@material-ui/core/styles/colorManipulator";

const useStyles = makeStyles(theme => ({
  root: {
    padding: "2px",
    display: "flex",
    width: 200,
    marginBottom: 1,
    marginTop: 5
  },
  input: {
    backgroundColor: fade(theme.palette.secondary.light, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.secondary.light, 0.3)
    }
  },
  iconButton: {
    padding: 8
  },
  divider: {
    width: 1,
    height: 28,
    marginTop: 5
  },
  grow: {
    flexGrow: 1
  }
}));

function SearchBar(props) {
  const classes = useStyles();
  const [value, setValue] = useState("");

  const handleChange = e => {
    setValue(e.target.value);
  };

  return (
    <>
      <div className={classes.grow} />
      <Paper className={classes.root} elevation={3}>
        <InputBase
          className={classes.input}
          placeholder="搜索"
          value={value}
          onChange={handleChange}
        />
        <Divider className={classes.divider} />
        <Link to={`/info/search/name__icontains=${value}`}>
          <IconButton className={classes.iconButton}>
            <SearchIcon />
          </IconButton>{" "}
        </Link>
      </Paper>
    </>
  );
}

export default SearchBar;
